export default __webpack_public_path__ + "static/media/weather.27c27b87.jpg";